import React from 'react';
import { SimplePage } from 'gatsby-theme-shopify-poulo';

const SimpleProduct = ({pageContext: { handle, title, image, id, relatedProduct }}) => {
  const data = { handle, title, image, id, relatedProduct };
  return <SimplePage data={data}></SimplePage>;
};

export default SimpleProduct;
